// Spec §8.3 — obrigatório marcar tudo antes de aprovar.
export const CHECKLIST = [
    { id: "noCharacters", label: "Sem personagens, criaturas ou pessoas" },
    { id: "noText", label: "Sem texto, letras, logos ou símbolos de marca" },
    { id: "seam", label: "Emenda com a carta imperceptível na escala da preview" },
    { id: "plates", label: "Regiões das placas sem detalhe que comprometa leitura" },
    { id: "bleed", label: "Nada na sangria que pareça corte de elemento importante" },
];

export const emptyChecklist = () => Object.fromEntries(CHECKLIST.map((i) => [i.id, false]));

export const checklistComplete = (state) => CHECKLIST.every((i) => state && state[i.id] === true);
